import React from 'react';
import './Home.css';
import Category from './Category';
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img className="home__banner img-fluid" src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Wireless/SamsungM/M51/GWTO/Pre_Launch/P38983965_IN_WLME_SamsungGalaxy_M51_New_Launch_M51_tallhero_1500x600_1._CB405468917_.jpg" />


                <div className="categorycust row">
                    {/* <Category />
                    <Category />
                    <Category />
                    <Category /> */}

                    <Category imgUrl="https://trello-attachments.s3.amazonaws.com/5f4aa40bb9475174cd87cffc/5f5956bf37e8e763e5167ac5/0287ef52ae0b5d244311a4112ddab539/desktop.jpg" catName="Desktop" />
                    <Category imgUrl="https://trello-attachments.s3.amazonaws.com/5f4aa40bb9475174cd87cffc/5f5956bf37e8e763e5167ac5/9490318300d6179d4be11847a420f3c7/laptop.jpg" catName="Laptop" />

                    <Category imgUrl="https://trello-attachments.s3.amazonaws.com/5f4aa40bb9475174cd87cffc/5f5956bf37e8e763e5167ac5/0287ef52ae0b5d244311a4112ddab539/desktop.jpg" catName="Mobile" />

                    <Category imgUrl="https://trello-attachments.s3.amazonaws.com/5f4aa40bb9475174cd87cffc/5f5956bf37e8e763e5167ac5/575ef246d54a218f8a41429c5546426a/camera.jpg" catName="Camera" />

                </div>

                <div className="home__productRow row">
                    {/*feature Product */}
                    {/*feature Product */}
                    {/*feature Product */}
                    <Product id={100} bestSeller={1} title="OPPO A11K (Deep Blue, 2GB RAM, 32GB Storage) with No Cost EMI/Additional Exchange Offers" imgUrl="https://m.media-amazon.com/images/I/714cFMW8okL._AC_UY218_.jpg" mprice={4000} oprice={3000} ratings={5} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10000} oprice={9000} ratings={2} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10000} oprice={9000} ratings={2} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10001} oprice={2000} ratings={5} qty={1} />

                    <Product id={100} bestSeller={1} title="OPPO A11K (Deep Blue, 2GB RAM, 32GB Storage) with No Cost EMI/Additional Exchange Offers" imgUrl="https://m.media-amazon.com/images/I/714cFMW8okL._AC_UY218_.jpg" mprice={4000} oprice={3000} ratings={5} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10000} oprice={9000} ratings={2} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10000} oprice={9000} ratings={2} qty={1} />

                    <Product id={101} bestSeller={0} title="Redmi 9 Prime (Mint Green, 4GB RAM, 64GB Storage)- Full HD+ Display & AI Quad Camera" imgUrl="https://m.media-amazon.com/images/I/710qEb8G3gL._AC_UY218_.jpg" mprice={10001} oprice={2000} ratings={5} qty={1} />


                    {/* <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product />
                    <Product /> */}


                </div>


            </div>
        </div>
    )
}

export default Home
